import React from 'react';

const Learning = ({ data }) => {
  const {
    main_title,
    main_icon,
    journey_title,
    journey_points,
    registrations_title,
    registrations_points,
  } = data;

  const webUrl = process.env.REACT_APP_WEB_URL;

  const half = Math.ceil((registrations_points?.length || 0) / 2);
  const regCol1 = registrations_points?.slice(0, half) || [];
  const regCol2 = registrations_points?.slice(half) || [];

  return (
    <section
      className="doctor-profile-learning-section"
      data-sal="slide-up"
      data-sal-duration="100"
    >
      <div className="container py-5">
        <div className="row">
          <div className="col-12 py-lg-5 pb-5 dp-heading-icon-wrapper">
            {main_icon && (
              <img
                src={`${webUrl}${main_icon}`}
                alt="icon"
                className="dp-heading-icon"
              />
            )}
            <h2 className="section-title text-capitalize">{main_title}</h2>
          </div>
        </div>

        <div className="row">
          <div className="col-12 mb-5">
            <p className="doctor-profile-learning-title">{journey_title}</p>
            <ul className="doctor-profile-points-list">
              {journey_points?.map((item, index) => (
                <li key={index}>
                  <span className="dp-year">{item.year}</span> – {item.text}
                </li>
              ))}
            </ul>
          </div>

          <div className="col-12 mt-3">
            <p className="doctor-profile-learning-title text-center">
              {registrations_title}
            </p>
            <div className="row mt-3">
              <div className="col-md-6 dp-border-right">
                <ul className="doctor-profile-points-list">
                  {regCol1.map((item, i) => (
                    <li key={i}>{item.text}</li>
                  ))}
                </ul>
              </div>
              <div className="col-md-6">
                <ul className="doctor-profile-points-list">
                  {regCol2.map((item, i) => (
                    <li key={i}>{item.text}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Learning;
